import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    position: 'relative',
    overflow: 'visible',
    minHeight: 'unset',
    '&:before': {
      content: '""',
      position: 'absolute',
      borderBottom: `3px solid ${idsTokens.tabs.default.color.border.enabled}`,
      height: 0,
      width: '100%',
      bottom: 0,
    },
    '&.apollo-theme-orientation-vertical:not(.apollo-theme-shape-box)': {
      '&:before': {
        borderRight: `3px solid ${idsTokens.tabs.default.color.border.enabled}`,
        width: 0,
        height: '100%',
        top: 0,
        right: 0,
      },
    },
    '&.overflow-white-space': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    '& label': {
      color: idsTokens.label.default.color.optional,
      fontSize: 'unset',
    },
    '&:has(.Mui-selected:hover) .MuiTabs-indicator': {
      backgroundColor: idsTokens.tabs.default.color.border.selected.hover,
    },
    '&:has(.Mui-selected:active) .MuiTabs-indicator': {
      backgroundColor: idsTokens.tabs.default.color.border.selected.pressed,
    },
    '&.apollo-theme-shape-box': {
      '&:before': {
        display: 'none',
      },
      '& .MuiTabs-indicator': {
        top: 0,
      },
      '&:has(.vertical) .MuiTabs-indicator': {
        left: 0,
      },
    },
    '& .MuiTabs-fixed': {
      overflow: 'visible !important',
    },
    '& .MuiTabs-scrollableX .MuiTab-root:after': {
      bottom: -3,
    },
    '&.MuiTabs-vertical .MuiTabs-indicator': {
      width: 3,
    },
  },
  indicator: {
    height: 3,
    borderBottomRightRadius: `${idsTokens.tabs.default.radius.horizontal.bottomRight}`,
    borderBottomLeftRadius: `${idsTokens.tabs.default.radius.horizontal.bottomLeft}`,
    backgroundColor: idsTokens.tabs.default.color.border.selected.enabled,
    transition: 'none',
  },
});
